<template>
  <div class="van-field-border mb-2" :class="transitionClass">
    <van-field readonly right-icon="arrow-down" :value="value" @click="onClick" :placeholder="finalPlaceholder" />
  </div>
</template>

<script>
export default {
  name: 'CascaderField',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    isTransition: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // fieldValue: ''
    }
  },
  computed: {
    finalPlaceholder() {
      return this.placeholder.trim() || '请选择'
    },
    transitionClass() {
      return this.isTransition ? 'transition-x' : ''
    }
  },
  created() {},
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.transition-x {
  animation: transition-x 0.25s linear;
}
</style>
